import axios from "axios";

export const extraApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

export const EXTRA_TOKEN_KEY = "pv_extra_token";

export function setExtraToken(token) {
  if (token) localStorage.setItem(EXTRA_TOKEN_KEY, token);
  else localStorage.removeItem(EXTRA_TOKEN_KEY);
}

export function getExtraToken() {
  return localStorage.getItem(EXTRA_TOKEN_KEY) || "";
}

export function extraAuthHeaders() {
  const t = getExtraToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
}

// Errori API → stringa sicura (FastAPI 422 ritorna array di oggetti)
export function apiDetail(e, fallback) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : "")).filter(Boolean).join(" ") || fallback;
  return fallback;
}

// Accetta "12/04/1985", "12-04-1985" e "1985-04-12" → ISO "1985-04-12" (null se non valida)
export function normalizeBirthDate(raw) {
  const s = (raw || "").trim();
  let d, m, y;
  let match = s.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{4})$/);
  if (match) { d = +match[1]; m = +match[2]; y = +match[3]; }
  else {
    match = s.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
    if (match) { y = +match[1]; m = +match[2]; d = +match[3]; }
    else return null;
  }
  const now = new Date().getFullYear();
  if (y < 1900 || y > now || m < 1 || m > 12 || d < 1 || d > 31) return null;
  const dt = new Date(Date.UTC(y, m - 1, d));
  if (dt.getUTCFullYear() !== y || dt.getUTCMonth() !== m - 1 || dt.getUTCDate() !== d) return null;
  return `${y}-${String(m).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
}
